import {IAuthSignIn} from "../../../types/auth";

export default {
    email: "",
    pwd: "",
    applicationName: "wb"
} as IAuthSignIn;
